import {RouteObject} from 'react-router-dom';
import {ProtectedRoute} from '../auth/require-authorization';
import {ROUTES} from '../routes';
import {FieldListing} from './field-listing';
import {FieldCreate, FieldUpdate} from './field-create-update';

export const FieldRoutes: RouteObject = {
  path: ROUTES.ADMIN.FIELDS.path,
  element: <ProtectedRoute role={'Global Admin'} />,
  children: [
    {
      path: ROUTES.ADMIN.FIELDS.INDEX.path,
      element: <FieldListing />,
    },
    {
      path: ROUTES.ADMIN.FIELDS.CREATE.path,
      element: <FieldCreate />,
    },
    {
      path: ROUTES.ADMIN.FIELDS.DETAIL.path,
      element: <FieldUpdate />,
    },
  ],
};
